import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ServicesIntroSection from '../components/ServicesIntroSection';
import CoachingServicesSection from '../components/CoachingServicesSection';
import {motion} from 'framer-motion';

const CoachingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-12">
        {/* Hero Section */}
        <section className="py-20 bg-sage-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <motion.h1
              initial={{opacity: 0, y: 30}}
              animate={{opacity: 1, y: 0}}
              transition={{duration: 0.8}}
              className="text-4xl md:text-5xl font-canela font-light text-gray-900 mb-6"
            >
              Divorce Coaching Services
            </motion.h1>
            <motion.p
              initial={{opacity: 0, y: 30}}
              animate={{opacity: 1, y: 0}}
              transition={{duration: 0.8, delay: 0.2}}
              className="text-xl text-gray-700 font-inter leading-relaxed"
            >
              Professional support to guide you through one of life's most challenging transitions
            </motion.p>
          </div>
        </section>

        {/* Coaching Services Section - Now appears first */}
        <CoachingServicesSection />

        {/* Services Introduction Section - Now appears after services */}
        <ServicesIntroSection />

        {/* Additional Information */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{opacity: 0, y: 30}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.8}}
              viewport={{once: true}}
              className="text-center space-y-8"
            >
              <h2 className="text-3xl font-canela font-light text-gray-900">
                What to Expect
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
                <div className="text-center">
                  <div className="w-16 h-16 bg-sage-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl font-canela text-sage-400">1</span>
                  </div>
                  <h3 className="text-lg font-inter font-medium text-gray-900 mb-2">
                    Safe Space
                  </h3>
                  <p className="text-gray-600 font-inter text-sm">
                    A confidential, non-judgmental environment to process your emotions and thoughts
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-sage-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl font-canela text-sage-400">2</span>
                  </div>
                  <h3 className="text-lg font-inter font-medium text-gray-900 mb-2">
                    Practical Guidance
                  </h3>
                  <p className="text-gray-600 font-inter text-sm">
                    Tools and strategies to help you navigate decisions and communicate effectively
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-sage-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl font-canela text-sage-400">3</span>
                  </div>
                  <h3 className="text-lg font-inter font-medium text-gray-900 mb-2">
                    Future Focus
                  </h3>
                  <p className="text-gray-600 font-inter text-sm">
                    Creating a vision for your future and actionable steps to achieve your goals
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CoachingPage;